export enum UgovorFormModeEnum {
  AneksUgovora = 'aneksUgovora',
  AneksPodugovora = 'aneksPodugovora',
  Ugovor = 'ugovor',
  Podugovor = 'podugovor',
}



// WEBPACK FOOTER //
// ./src/app/pages/sifarnici/ugovori/enums/ugovor-form-mode.enum.ts